<template>
  <BaseCard>
    <BaseCardBody>
      <div class="space-y-8">
        <div class="space-y-1">
          <h3 class="text-lg leading-6 font-medium text-gray-900">Delete template</h3>
          <p class="max-w-2xl text-sm text-gray-500">Permanently delete this template.</p>
        </div>

        <div class="flex items-baseline">
          <BaseFormCheckbox v-model="confirmed" :disabled="loading" />
          <p class="inline-block ml-2 measure">
            I understand that by deleting this template, all of its resources and data will be
            permanently deleted.
          </p>
        </div>

        <BaseButton danger :disabled="!confirmed || loading" @click="deleteTemplate">
          Delete template
        </BaseButton>
      </div>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
export default {
  inject: ['destroyAccProductTemplate'],
  props: {
    accProductTemplateId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      confirmed: false,
      loading: false,
    };
  },
  methods: {
    async deleteTemplate() {
      try {
        this.loading = true;
        await this.destroyAccProductTemplate();
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
